import React, { useEffect, useState } from 'react'
import { Grid, Card, CardMedia, CardContent, Typography, Chip, Box, CircularProgress, Button, Slider, Divider, Menu, FormControlLabel, Checkbox, RadioGroup, Radio, Skeleton } from '@mui/material';
import Sorting from '../../components/prodcomps/sorting/Sorting';
import Filter from '../../components/prodcomps/filterbar/Filter';
import SimilarProducts from '../../components/SimilarProducts/SimilarProducts';
import { FilterIcon, Wishlist } from '../../../Svg';
import { useLocation, useNavigationType, useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getAllProductsByCategory, getFilteredProducts, getMaximumAmountOfProduct, getSubCategoryNames, setFilterValuesCate, resetFilterOptionsForCategory } from '../../../redux/productsSlice';
import ErrorPage from '../errorpage/ErrorPage';
import { getProfile, resetUnreadCountsThunk } from '../../../redux/userSlice';
import SignIn from '../../auth/signin/SignIn';
import { addWishlist, getAllWishlist } from '../../../redux/wishlistSlice';
import { toast } from 'react-toastify';
import { setVisible } from '../../../redux/authModelSlice';
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import styles from './product.module.css'
import CustomSeparator from '../../components/maincomps/breadcrumbs/Breadcrumbs';
import breadcrumbStyle from '../../components/maincomps/breadcrumbs/breadcrumbs.module.css'
import ErrorData from '../errorpage/ErrorData';
import Loader from '../../components/Loader/Loader';
import { useCurrency } from '../../context/CurrencyContext';

const ProductsWithSubCategory = () => {
    const sortingOptions = [
        {
            name: 'defaultSorting',
            label: 'Default Sorting'
        },
        {
            name: 'readyToShip',
            label: 'Ready To Ship'
        },
        {
            name: 'madeToOrder',
            label: 'Made to order'
        },
        {
            name: 'priceHighToLow',
            label: 'Price - high to low'
        },
        {
            name: 'priceLowToHigh',
            label: 'Price - low to high'
        },

    ];

    const { id } = useParams();
    const location = useLocation();
    const navType = useNavigationType();
    const item = location?.state?.name;
    const subCatName = location?.state?.subcategories?.find(i => i?._id === id)
    const subTypeName = subCatName?.name;
    const categoryId = location?.state?._id
    const { formatPrice } = useCurrency();
    // console.log('location==========', location);


    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { isFilterLoading, filterOptionsForCategory, isRefresh, filteredProductData, maximumAmountOfProductData } = useSelector((state) => state.products);
    console.log('isFilterLoading', isFilterLoading);

    console.log('filteredProductData', filteredProductData);

    const maxPriceProduct = maximumAmountOfProductData?.pricing?.finalSalePrice?.value;
    const { wishlistData } = useSelector((state) => state.wishlist)
    const wishlistRefresh = useSelector((state) => state.wishlist.isRefresh)
    const [anchorEl, setAnchorEl] = useState(null);
    const [priceRange, setPriceRange] = useState([100000, maxPriceProduct]);
    const [anchorElSorting, setAnchorElSorting] = useState(null);
    const [selectedSort, setSelectedSort] = useState("defaultSorting");
    const token = localStorage.getItem("token");

    useEffect(() => {
        const getAllProductByFilter = async () => {
            try {
                await dispatch(getFilteredProducts({ ...filterOptionsForCategory, subcategory: id }));
            } catch (error) {
                console.log(error);
            }
        };
        getAllProductByFilter();
    }, [dispatch, filterOptionsForCategory, id, isRefresh]);


    useEffect(() => {
        if (navType !== "POP") {
            dispatch(resetFilterOptionsForCategory());
            dispatch(getFilteredProducts({ subcategory: id }));
        }
    }, [dispatch, id, navType]);


    useEffect(() => {
        if (filterOptionsForCategory) {
            dispatch(getFilteredProducts({ ...filterOptionsForCategory, subcategory: id }));
        }
    }, [dispatch, filterOptionsForCategory, id]);

    useEffect(() => {
        if (navType === "POP" && filterOptionsForCategory?.sortBy) {
            dispatch(getFilteredProducts({ ...filterOptionsForCategory, subcategory: id }));
        }
    }, [navType, dispatch, filterOptionsForCategory, id]);

    useEffect(() => {
        const prevSubCategoryId = sessionStorage.getItem("lastSubCategoryId");
        if (prevSubCategoryId && prevSubCategoryId !== id) {
            setSelectedSort("defaultSorting");
        }
        sessionStorage.setItem("lastSubCategoryId", id);
    }, [id]);

    useEffect(() => {
        if (filterOptionsForCategory?.sortBy) {
            setSelectedSort(filterOptionsForCategory.sortBy);
        }
    }, [filterOptionsForCategory]);


    useEffect(() => {
        if (maxPriceProduct) {
            setPriceRange([100000, maxPriceProduct]);
        }
    }, [maxPriceProduct]);


    useEffect(() => {
        dispatch(getAllWishlist())
    }, [dispatch, wishlistRefresh])


    const handleWishlist = async (value) => {
        let data = {
            productId: value,
            quantity: 1
        }
        dispatch(addWishlist(data))
    }

    //Filter Categories
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };



    const handlePriceChange = (event, newValue) => {
        // console.log('newValue===========',newValue);

        setPriceRange(newValue);
        // Convert array to string format "min-max"
        const priceRangeString = `${newValue[0]}-${newValue[1]}`;

        dispatch(setFilterValuesCate({ priceRange: priceRangeString }));
    };



    const handleClearAll = () => {
        setPriceRange([100000, maxPriceProduct])

        dispatch(getFilteredProducts({ subcategory: id })); // Fetch all products again
    };

    const handleApply = () => {
        handleClose(); // Close dropdown after applying
    };


    //Sorting
    const openSorting = Boolean(anchorElSorting);

    const handleClickSorting = (event) => {
        setAnchorElSorting(event.currentTarget);
        // dispatch(setFilterValuesCate({ sortBy: event }))
    };

    const handleCloseSorting = () => {
        setAnchorElSorting(null);
    };

    const handleSortChange = (event) => {
        // console.log('event===========', event.target.value);
        setSelectedSort(event.target.value);
        dispatch(setFilterValuesCate({ sortBy: event.target.value }))
        handleCloseSorting();
    };


    useEffect(() => {
        if (navType === "POP") {
            const lastId = sessionStorage.getItem("lastProductId");
            if (lastId && filteredProductData && filteredProductData.length > 0) {
                let attempts = 0;
                const maxAttempts = 10;
                const interval = setInterval(() => {
                    const el = document.getElementById(`prod-${lastId}`);
                    if (el) {
                        el.scrollIntoView({ behavior: "auto", block: "center" });
                        sessionStorage.removeItem("lastProductId");
                        clearInterval(interval);
                    } else if (++attempts > maxAttempts) {
                        clearInterval(interval);
                    }
                }, 1);
                return () => clearInterval(interval);
            }
        } else {
            window.scrollTo(0, 0);
        }
    }, [location.key, navType, filteredProductData]);


    return (
        <div>
            <div className={breadcrumbStyle.breadcrumbStyle}>
                <CustomSeparator home="Home" type={item} subType={subTypeName} id={categoryId} />
            </div>
            <Box sx={{ padding: '0px 8%', display: 'flex', alignItems: 'center', justifyContent: "center" }}>
                <Typography mt={4}
                    sx={{
                        fontSize: '36px',
                        color: '#000',
                        fontWeight: 500,
                        lineHeight: '38px',
                        textAlign: "center",
                        textTransform: 'uppercase'
                    }}
                >
                    {subTypeName}
                    {/* <Typography
                        sx={{
                            fontSize: '16px',
                            color: '#000',
                            fontWeight: 500,
                            textAlign: "center"

                        }}>
                        Find all the jewellery you will need here.
                    </Typography> */}
                </Typography>
            </Box>
            <Box sx={{ padding: '16px 8%', display: 'flex', justifyContent: 'space-between', alignItems: { xs: 'flex-start' } }}>


                <Box sx={{
                    display: 'flex', alignItems: 'center', gap: '10px',
                    flexDirection: {
                        xs: 'column',   // stack on small/mobile view
                        md: 'row'       // horizontal layout on larger screens
                    }, alignItems: { xs: 'flex-start', md: 'center' }
                }} >

                    <Box sx={{
                        display: 'flex', justifyContent: 'flex-start', alignItems: 'center', gap: '10px', alignItems: { xs: 'flex-start' }
                    }}>
                        {/* Filter Button */}
                        <div
                            className={styles.filterStyle}
                            onClick={handleClick}
                        >
                            <div><FilterIcon /></div>
                            <span>Filter</span>
                            {/* <div className={styles.numStyle}>
                            {selectedCategories?.length}
                        </div> */}
                        </div>

                        {/* Filter Menu */}
                        <Menu
                            anchorEl={anchorEl}
                            open={open}
                            onClose={handleClose}
                            anchorOrigin={{
                                vertical: "bottom",
                                horizontal: "left",
                            }}
                            transformOrigin={{
                                vertical: "top",
                                horizontal: "left",
                            }}
                            PaperProps={{
                                sx: {
                                    borderRadius: "12px",
                                    boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
                                    p: 2,
                                    minWidth: "300px",
                                    padding: '10px 16px',
                                    marginTop: "10px",
                                },
                            }}
                        >
                            {/* Filter Header */}
                            <Box display="flex" justifyContent="space-between" alignItems="center" >
                                <Typography variant="body1" fontWeight="bold" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: '10px' }}>
                                    Filter
                                    <div style={{ marginTop: 5 }}>
                                        <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M6.68125 14.8C7.86866 14.8 8.83125 13.8374 8.83125 12.65C8.83125 11.4626 7.86866 10.5 6.68125 10.5C5.49384 10.5 4.53125 11.4626 4.53125 12.65C4.53125 13.8374 5.49384 14.8 6.68125 14.8Z" stroke="black" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M4.53 12.6504H1.5" stroke="black" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M16.5019 12.6504H11.1719" stroke="black" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M11.3102 5.8C12.4976 5.8 13.4602 4.83741 13.4602 3.65C13.4602 2.46259 12.4976 1.5 11.3102 1.5C10.1227 1.5 9.16016 2.46259 9.16016 3.65C9.16016 4.83741 10.1227 5.8 11.3102 5.8Z" stroke="black" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M13.4688 3.65039H16.4987" stroke="black" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M1.5 3.65039H6.83" stroke="black" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </div>
                                </Typography>
                                <Button onClick={handleClearAll} sx={{ fontSize: "0.875rem", color: "#ff5722", textTransform: 'capitalize' }}>
                                    Clear All
                                </Button>
                            </Box>

                            <Divider sx={{ mb: 2 }} />

                            {/* Categories Section */}

                            {/* Price Filter Section */}
                            <Typography variant="body2" color="text.secondary" fontWeight="bold" mt={3} mb={1}>
                                PRICE FILTER
                            </Typography>
                            <Box display="flex" alignItems="center" flexDirection='column' >
                                <Slider
                                    value={priceRange}
                                    onChange={handlePriceChange}
                                    min={100000}
                                    max={maxPriceProduct}
                                    valueLabelDisplay="auto"
                                    sx={{
                                        color: "#ff5722",
                                        "& .MuiSlider-thumb": {
                                            width: '12px',
                                            height: '12px',
                                            boxShadow: "0px 4px 10px rgba(0,0,0,0.2)",
                                        },
                                        "& .MuiSlider-root": {
                                            padding: '16px 0',
                                            height: "2px", // General height of the slider
                                        },
                                        "& .MuiSlider-rail": {
                                            height: "2px", // Height of the rail
                                        },
                                        "& .MuiSlider-track": {
                                            height: "2px",  // Same height
                                        },
                                    }}
                                />
                                <Box display="flex" alignItems="center" justifyContent='space-between' width='100%'>
                                    <Typography variant="body2" sx={{ minWidth: "40px" }}>
                                        From {formatPrice(priceRange[0])}
                                    </Typography>
                                    <Typography variant="body2" sx={{ minWidth: "40px" }}>
                                        To {formatPrice(priceRange[1])}
                                    </Typography>
                                </Box>
                            </Box>
                            <Box mt={2} display="flex" justifyContent="flex-end">
                                <Button
                                    variant="contained"
                                    onClick={handleApply}
                                    sx={{
                                        textTransform: "none",
                                        backgroundColor: "#ff5722",
                                        color: "#fff",
                                        px: 3,
                                        py: 1,
                                        "&:hover": { backgroundColor: "#e64a19" },
                                    }}
                                >
                                    Apply
                                </Button>
                            </Box>
                        </Menu>
                    </Box>
                </Box>

                <Box sx={{
                    display: 'flex', alignItems: 'center', gap: '10px',
                    flexDirection: {
                        xs: 'column-reverse',   // stack on small/mobile view
                        md: 'row'       // horizontal layout on larger screens
                    }, alignItems: { xs: 'flex-end', md: 'center' }
                }}>
                    {/* Trigger Button */}

                    <div className={styles.showingText}>
                        Showing {filteredProductData?.length || 0} results
                    </div>

                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Button
                            variant="outlined"
                            endIcon={<KeyboardArrowDownIcon />}
                            onClick={handleClickSorting}
                            sx={{
                                textTransform: "none",
                                fontWeight: "bold",
                                color: "#000",
                                borderColor: "#ddd",
                                backgroundColor: "#fff",
                                minWidth: '160px',
                            }}
                        >
                            {filterOptionsForCategory?.sortBy === 'readyToShip' ? 'Ready to ship'
                                : filterOptionsForCategory?.sortBy === 'madeToOrder' ? 'Made to order'
                                    : filterOptionsForCategory?.sortBy === 'priceHighToLow' ? 'Price high to low'
                                        : filterOptionsForCategory?.sortBy === 'priceLowToHigh' ? 'Price low to high'
                                            : "Default sorting"
                            }
                        </Button>

                        {/* Menu */}
                        <Menu
                            anchorEl={anchorElSorting}
                            open={openSorting}
                            onClose={handleCloseSorting}
                            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                            transformOrigin={{ vertical: "top", horizontal: "center" }}
                            PaperProps={{
                                sx: {
                                    borderRadius: "8px",
                                    boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
                                    p: 2,
                                    minWidth: "200px",
                                    marginLeft: "-20px",
                                },
                            }}
                        >
                            <Typography
                                variant="body2"
                                color="text.secondary"
                                sx={{ fontWeight: "bold", mb: 1 }}
                            >
                                SORT BY
                            </Typography>
                            <RadioGroup value={selectedSort} onChange={handleSortChange}>
                                {sortingOptions.map((option) => (
                                    <FormControlLabel
                                        key={option}
                                        value={option?.name}
                                        control={<Radio
                                            sx={{
                                                color: "#999", // Default color
                                                "&.Mui-checked": {
                                                    color: "#000", // Custom checked color
                                                    // backgroundColor:'#EFEEF1'
                                                },
                                            }}
                                        />}
                                        label={option?.label}
                                        sx={{
                                            "& .MuiFormControlLabel-label": {
                                                fontSize: "0.875rem",
                                            },
                                            "& .MuiSvgIcon": {
                                                fill: 'red'
                                            },
                                            "&.Mui-checked": {
                                                // color: "#000", // Custom checked color
                                                backgroundColor: '#EFEEF1'
                                            },
                                        }}
                                    />
                                ))}
                            </RadioGroup>
                        </Menu>
                    </Box>
                </Box>
            </Box>

            {(isFilterLoading || filteredProductData?.length === 0) ? (
                <Loader />
            ) :
                <>
                    {filteredProductData?.length > 0 ? (
                        <Box sx={{ padding: '16px 8%' }}>
                            <Grid container spacing={3}>
                                {filteredProductData?.map((product) => {
                                    const isWishlisted = Array.isArray(wishlistData)
                                        ? wishlistData.some((item) => item?.productId === product?._id)
                                        : false
                                    return (
                                        <Grid item xs={12} sm={6} md={4} key={product._id} >
                                            <Card sx={{ position: 'relative', borderRadius: '0px', }}>

                                                {/* Tag */}
                                                {product?.discount === 0 ? (
                                                    null
                                                ) : (
                                                    <Chip
                                                        label={`${product?.discount}% off`}
                                                        sx={{
                                                            position: 'absolute',
                                                            top: '8px',
                                                            left: '8px',
                                                            backgroundColor: '#FEF5EB',
                                                            color: '#000',
                                                        }}
                                                    />
                                                )}

                                                <Box
                                                    id={`prod-${product._id}`}
                                                    sx={{ height: '320px', backgroundColor: '#000', boxSizing: 'border-box' }}
                                                    onClick={() => {
                                                        sessionStorage.setItem("lastProductId", product._id);
                                                        navigate(`/prodDescription/${product?._id}`);
                                                    }}
                                                >
                                                    <CardMedia
                                                        component="img"
                                                        image={product?.featurerdImage}
                                                        alt={product?.productName}
                                                        sx={{ objectFit: 'contain', height: '100%', width: '100%', backgroundColor: '#000', cursor: 'pointer' }}
                                                    />
                                                </Box>

                                                <CardContent sx={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between" }}>
                                                    <Box>
                                                        <div className={styles.productName}>
                                                            {product?.productName}
                                                            {/* {product?.productName.length > 25 ? `${product?.productName.substring(0, 25)}...` : product?.productName} */}
                                                        </div>
                                                        <Box sx={{ display: 'flex', gap: '8px', alignItems: "flex-end" }}>
                                                            <div className={styles.sellingPrice}>
                                                                {formatPrice(product?.sellingPrice)}
                                                            </div>
                                                            {product?.discount === 0 ? (
                                                                null
                                                            ) : (
                                                                <Typography
                                                                    variant="body2"
                                                                    sx={{ textDecoration: 'line-through', color: 'gray', }}
                                                                >
                                                                    {formatPrice(product?.totalPrice)}
                                                                </Typography>
                                                            )}
                                                        </Box>
                                                    </Box>
                                                    <Box
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            e.stopPropagation();
                                                            if (token) {
                                                                handleWishlist(product?._id);
                                                            } else {
                                                                dispatch(setVisible('signin'))
                                                            }
                                                        }}
                                                    // onClick={handleWishlist}
                                                    >
                                                        {/* <Wishlist color = {'white'} borderColor ={'black'}/> */}
                                                        <Wishlist color={isWishlisted ? 'red' : 'white'} borderColor={isWishlisted ? 'red' : 'black'} />
                                                    </Box>
                                                </CardContent>
                                            </Card>
                                        </Grid>
                                    )
                                })}
                            </Grid>
                        </Box>
                    ) : (
                        <ErrorData />
                    )}
                </>
            }

        </div>
    )
}

export default ProductsWithSubCategory
